/**
 * Decodes the same zigzag + varint delta format as gpx-device-api {@code IntegerDeltaSeriesCodec} (Google polyline-style integers).
 */
export function decodeIntegerDeltaSeries(encoded: string): number[] {
  const values: number[] = [];
  const len = encoded.length;
  let index = 0;
  let prev = 0;

  while (index < len) {
    let result = 0;
    let shift = 0;
    let b = 0;
    do {
      if (index >= len) {
        return values;
      }
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const zz = result;
    // Zigzag decode must use unsigned half (>>>), not >> — otherwise values past 2^31-1
    // (e.g. first unix-second delta) corrupt and timestamps become negative.
    const delta = (zz >>> 1) ^ (-(zz & 1));
    prev += delta;
    values.push(prev);
  }

  return values;
}
